<!--  -->
<template>
    <div class="news-main main ">
        <div class="pt10 mb25 bg-gray">
            <div class="psearch htmldiv pt25 pb25 tcenter">
                <div class="search-input bgw br5 ofhidden prelative dinline-block">
                    <input ref="searchInput" v-model.trim="searchInput" @keydown.enter="_searchInput" placeholder="请输入关键字搜索"
                        type="text" name="" maxlength="">
                    <div class="search-btn pabsolute cpointer tcenter" @click="_searchInput">
                        <span class="iconfont icon-sousuo"></span>
                    </div>
                </div>
                <span @click="_goBack" class="dinline-block iconfont icon-fanhui fs20 cpointer mr20" title="返回上一页"></span>
            </div>
        </div>
        <div class="htmldiv mht-300 bgw mb20">
            <div class="fs18 mcolor"> <span class="iconfont icon-s_sousuojieguo fs20 mr5"></span>搜索结果</div>
            <template v-if="!isFirst">
                <div v-if="!count" class="mt40 tcenter tc9 fs18 no-cont">
                    <div :class="isLoad ? 'icon-jiazaizhong' : 'icon-kongneirong'" class="iconfont"></div>
                    {{ isLoad ? '稍等，数据加载中' : '抱歉，没有搜索到相关内容' }}
                </div>
                <noticeList v-else :newsList="newsList" :link="'news/sdetail'" />
                <Page v-if="count" :pageNum="page + 1" :pageSize="pageSize" :count="count" @chagePage="chagePage" />
            </template>
            <template v-else>
                <div style="height: 50px;"></div>

            </template>
        </div>
        <div class="pt25"></div>
    </div>
</template>
<script>
import NoticeList from '@/components/notice/NoticeList'
import Page from '@/components/common/MyPagination'
export default {
    name: 'Search',
    data() {
        return {
            newsList: [],
            page: 0,
            pageSize: 15,
            count: 0,
            searchInput: '',
            isFirst: true,
            isLoad: false
        }
    },
    watch: {
        $route: {
            //immediate: true,
            deep: true,
            handler: function (nV, oV) {
                // alert()
                //if (nV.params.id != oV.params.id) {
                this.isLoad = false
                this.count = 0
                this.page = 0
                this.initData()
                //}
            }
        }
    },
    components: {
        NoticeList,
        Page
    },
    created() {
        if (this.$route.query.sInput) {
            this.isFirst = false
            this.searchInput = this.$route.query.sInput
            this.getNewsList()
        }

    },
    methods: {
        _searchInput() {
            if (this.inputFocus()) {
                this.initData()
                this.getNewsList()
            }
        },
        _goBack() {
            this.$router.go(-1)
        },
        initData() {
            this.page = 0
            this.count = 0
        },
        getNewsList() {
            this.isLoad = true
            const query = {
                page: this.page + 1,
                perPage: this.pageSize,
                search: this.searchInput,
            }
            //console.log(query)
            this.$request.get('article/search', query, res => {
                if (res.data.code == 200) {
                    const data = res.data.data
                    //this.newsList = data.articleList
                    this.newsList = data.data
                    this.count = parseInt(data.total)

                } else if (res.data.code == 220) {
                    this.inputFocus()
                }
                this.isLoad = false
                this.isFirst = false
            }, err => {
                //console.log(err)
                this.isLoad = false
                this.isFirst = false
            })
        },
        chagePage(page) {
            this.page = page - 1
            this.getNewsList()
        },
        inputFocus() {
            if (!this.$refs.searchInput.value) {
                alert('请输入关键词搜索')
                this.$refs.searchInput.focus()
                return false
            }
            return true
        }

    },

}
</script> 

<style lang='less' scoped>
.no-cont {
    margin-top: 80px;
}

.no-cont .iconfont {
    font-size: 80px;
    margin-bottom: 80px;
}

.psearch {
    border-bottom: 1px solid #f2f1f1;
}

.search-input {
    margin: 0 auto;
    width: 80%;
    height: 40px;
    border: 1px solid #3460d3;
}

.search-input:focus {
    box-shadow: 0 0 15px inset var(--mcolor);
    border-color: var(--mcolor);
}



.search-input input {
    display: block;
    padding: 0 100px 0 10px;
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    font-size: 16px;
    color: #000;
}

.search-input .search-btn {
    background: linear-gradient(to bottom, #609ae4, #3460d3);
    width: 80px;
    right: 0;
    top: 0;
    bottom: 0;
    color: #fff;
}

.search-input .icon-sousuo {
    position: relative;
    top: 2px;
    font-size: 30px;
    color: #fff;
}

.search-input .icon-sousuo:hover {
    margin-top: -1px;
}

.icon-fanhui {
    position: relative;
    font-size: 24px;
    left: 10px;
    top: -10px;
    color: #fff;
}

.mcolor {
    position: relative;
    margin-bottom: -20px;
    padding: 40px 0 0 30px;
}

.icon-fanhui {
    color: var(--mcolor);
}

.no-cont {
    margin-top: 60px;
}
</style>
